import classnames from 'classnames'
import Group from 'entities/group'
import PropTypes from 'prop-types'
import React from 'react'
import { propTypeInstantiableTo } from 'supports/custom_prop_types'
import Link from '../link'
import GroupDropdown from './group_dropdown'
import styles from './header.module.scss'
import SettingDropdown from './setting_dropdown'

const Header = ({ companyName, defaultLogoUrl, group, linkUrl, logoUrl, name }) => (
  <div className={styles.header}>
    <div className={styles.container}>
      <Link className={styles.logoLink} href={linkUrl}>
        <img className={logoUrl ? styles.logo : styles.defaultLogo} src={logoUrl || defaultLogoUrl} alt={companyName} />
      </Link>
      <div className={styles.headerNavigation}>
        <GroupDropdown name={name} group={group} />
        <SettingDropdown />
        <Link className={styles.help} href="https://help.refcome.com" openInNew>
          <i className={classnames('ic-help', styles.helpIcon)} />
        </Link>
      </div>
    </div>
  </div>
)

Header.propTypes = {
  companyName: PropTypes.string.isRequired,
  defaultLogoUrl: PropTypes.string,
  group: propTypeInstantiableTo(Group).isRequired,
  linkUrl: PropTypes.string,
  logoUrl: PropTypes.string,
  name: PropTypes.string.isRequired
}

Header.defaultProps = {
  defaultLogoUrl: null,
  linkUrl: null,
  logoUrl: null
}

export default Header
